import * as React from "react";
import { Button, type ButtonProps } from "~/components/ui/button";
import { cn } from "~/lib/utils";
import { FILTER_CONTROL_INTERACTIVE_CLASS } from "../AssetScreenerFilters/styles";

// // // //

interface FilterControlButtonProps extends Omit<
    ButtonProps,
    "variant" | "size"
> {
    justify?: "start" | "between";
}

export const FilterControlButton = React.forwardRef<
    HTMLButtonElement,
    FilterControlButtonProps
>(({ className, justify = "between", ...props }, ref) => {
    return (
        <Button
            ref={ref}
            variant="outline"
            className={cn(
                FILTER_CONTROL_INTERACTIVE_CLASS,
                "h-9 w-full border-border shadow-none",
                justify === "start" && "justify-start",
                justify === "between" && "justify-between",
                className,
            )}
            {...props}
        />
    );
});
FilterControlButton.displayName = "FilterControlButton";
